import { render, staticRenderFns } from "./ShopCouponView.vue?vue&type=template&id=9c159dae&scoped=true"
import script from "./ShopCouponView.vue?vue&type=script&lang=js"
export * from "./ShopCouponView.vue?vue&type=script&lang=js"
import style0 from "./ShopCouponView.vue?vue&type=style&index=0&id=9c159dae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c159dae",
  null
  
)

export default component.exports